<template>
  <back-button type="text">
    <span class="easy-back-button">
      <v-icon>mdi-arrow-left-bold</v-icon>
      <span class="label">戻る</span>
    </span>
  </back-button>
</template>

<script>
import BackButton from "@/components/atoms/BackButton.vue";
export default {
  name: "EasyBackButton",
  components: {BackButton}
}
</script>

<style lang="scss" scoped>
@import "./easy.scss";

.v-btn {
  padding: 0 !important;
}

.easy-back-button {
  color: $default-text-color !important;
  font-size: 1rem;
}

.label {
  margin-left: 0.3rem;
  vertical-align: middle;
}
</style>
